<div class="td-wb-empty__icon-container">
  <ng-container [ngTemplateOutlet]="customIcon() ? customIconTemplate : defaultIconTemplate" />
</div>
<div class="td-wb-empty__header-container">
  <ng-content select="td-wb-empty-header" />
</div>
<ng-content select="td-wb-empty-sub-header" />

<ng-template #defaultIconTemplate>
  <td-wb-icon iconId="empty" size="54x65" />
</ng-template>

<ng-template #customIconTemplate>
  <ng-content select="[tdWbEmptyIcon]" />
</ng-template>
